import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation} from 'react-router-dom';
// import { useAuth } from '../../context/AuthContext';
import { 
    Dashboard,
    Users,
    Shield,
    BriefCase,
    UserCheck,
    // Settings,
    // FileText,
    // Bell,
    // HelpCircle,
    ChevronRight,
    Menu,
    X,
    Activity,
    // Database,
    // Globe,
    // Mail,
    // MessageSquare,
} from '../../assets/icons';
// import Logo from '../../assets/icons/logo.svg';
import '../../assets/css/layout/admin_sidebar.css';

const AdminSidebar = ({ isCollapsed, setIsCollapsed }) => {
    const location = useLocation();
    // const navigate = useNavigate();
    // const { user } = useAuth();
    
    // States for submenu toggles
    const [expandedMenus, setExpandedMenus] = useState({});
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    // const [recentActivities] = useState([
    //     { id: 1, action: 'New user registration', time: '2 min ago', type: 'user' },
    //     { id: 2, action: 'Case resolved', time: '5 min ago', type: 'case' },
    //     { id: 3, action: 'Payment received', time: '10 min ago', type: 'payment' }
    // ]);
    
    // Menu structure with icons and submenus
    const menuItems = [
        {
            // title: 'Overview',
            items: [
                {
                    title: 'Dashboard',
                    icon: Dashboard,
                    path: '/admin',
                    badge: null,
                    description: 'Main dashboard overview'
                },
                // {
                //     title: 'Analytics',
                //     icon: Analytics,
                //     path: '/admin/analytics',
                //     badge: 'New',
                //     description: 'Platform analytics and insights',
                //     submenu: [
                //         { title: 'Overview', icon: BarChart3, path: '/admin/analytics/overview' },
                //         { title: 'User Analytics', icon: TrendingUp, path: '/admin/analytics/users' },
                //         { title: 'Case Analytics', icon: PieChart, path: '/admin/analytics/cases' },
                //         { title: 'Revenue Analytics', icon: CreditCard, path: '/admin/analytics/revenue' }
                //     ]
                // }
        //     ]
        // },
        // {
        //     title: 'Management',
        //     items: [
                {
                    title: 'Case Management',
                    icon: Shield,
                    path: '/admin/cases',
                },
                // {
                //     title: 'User Management',
                //     icon: Users,
                //     path: '/admin/users',
                //     badge: '156',
                //     description: 'Manage platform users',
                //     submenu: [
                        { title: 'Farmers', icon: Users, path: '/admin/farmers' },
                        // { title: 'Farmers', icon: BriefCase, path: '/admin/users/farmers' },
                        { title: 'Veterinarians', icon: UserCheck, path: '/admin/doctors' },
                        { title: 'Labs', icon: Activity, path: '/admin/labs' },
                        // { title: 'User Roles', icon: Shield, path: '/admin/users/roles' },
                //     ]
                // },
                {
                    title: 'Farm Management',
                    icon: BriefCase,
                    path: '/admin/farms',
                    badge: null,
                    // description: 'Manage registered farms',
                    // submenu: [
                    //     { title: 'All Farms', icon: BriefCase, path: '/admin/farms' },
                    //     { title: 'Farm Verification', icon: Shield, path: '/admin/farms/verification' },
                    //     { title: 'Farm Categories', icon: Layers, path: '/admin/farms/categories' }
                    // ]
                },
                // {
                //     title: 'Payments',
                //     icon: CreditCard,
                //     path: '/admin/payments',
                //     badge: '12',
                //     description: 'Payment management',
                //     submenu: [
                //         { title: 'All Transactions', icon: CreditCard, path: '/admin/payments' },
                //         { title: 'Pending Payments', icon: Clock, path: '/admin/payments/pending' },
                //         { title: 'Revenue Reports', icon: TrendingUp, path: '/admin/payments/revenue' },
                //         { title: 'Payment Settings', icon: Settings, path: '/admin/payments/settings' }
                //     ]
                // }
        //     ]
        // },
        // {
        //     title: 'Content & Communication',
        //     items: [
                //  { title: 'Articles', icon: FileText, path: '/admin/articles' },
                // { title: 'Resources', icon: Database, path: '/admin/resources' },
                // { title: 'FAQs', icon: HelpCircle, path: '/admin/faqs' },
                // { title: 'Disease Database', icon: Activity, path: '/admin/database' },
                // { title: 'Messages', icon: MessageSquare, path: '/admin/communications/messages' },
                // { title: 'Notifications', icon: Bell, path: '/admin/communications/notifications' },
                // { title: 'Email Templates', icon: Mail, path: '/admin/communications/templates' },
                // { title: 'Broadcast', icon: Globe, path: '/admin/communications/broadcast' },
                    
        //     ]
        // },
        // {
        //     title: 'System',
        //     items: [
                // {
                //     title: 'Reports',
                //     icon: FileText,
                //     path: '/admin/reports',
                //     badge: null,
                //     description: 'System reports and exports',
                //     submenu: [
                //         { title: 'System Reports', icon: FileText, path: '/admin/reports/system' },
                //         { title: 'User Reports', icon: Users, path: '/admin/reports/users' },
                //         { title: 'Financial Reports', icon: CreditCard, path: '/admin/reports/financial' },
                //         { title: 'Export Data', icon: Database, path: '/admin/reports/export' }
                //     ]
                // },
                // {
                //     title: 'Settings',
                //     icon: Settings,
                //     path: '/admin/settings',
                //     // badge: null,
                //     // description: 'Platform configuration',
                //     // submenu: [
                //     //     { title: 'General Settings', icon: Settings, path: '/admin/settings/general' },
                //     //     { title: 'Security Settings', icon: Lock, path: '/admin/settings/security' },
                //     //     { title: 'API Management', icon: Zap, path: '/admin/settings/api' },
                //     //     { title: 'Backup & Restore', icon: Database, path: '/admin/settings/backup' }
                //     // ]
                // },
                // {
                //     title: 'Support',
                //     icon: HelpCircle,
                //     path: '/admin/support',
                    // badge: '3',
                    // description: 'Help and support center',
                    // submenu: [
                    //     { title: 'Help Center', icon: HelpCircle, path: '/admin/support/help' },
                    //     { title: 'Support Tickets', icon: MessageSquare, path: '/admin/support/tickets' },
                    //     { title: 'System Status', icon: Activity, path: '/admin/support/status' },
                    //     { title: 'Documentation', icon: FileText, path: '/admin/support/docs' }
                    // ]
                // }
            ]
        }
    ];
    
    // Handle window resize
    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth <= 768;
            setIsMobile(mobile);
            if (mobile) {
                setIsCollapsed(true);
            }
        };
        
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [setIsCollapsed]);
    
    // Auto-expand active menu on route change
    useEffect(() => {
        const currentPath = location.pathname;
        
        // Find and expand the menu that contains the current path
        menuItems.forEach(section => {
            section.items.forEach(item => {
                if (item.submenu) {
                    const hasActiveSubmenu = item.submenu.some(sub => 
                        currentPath.startsWith(sub.path)
                    );
                    if (hasActiveSubmenu) {
                        setExpandedMenus(prev => ({ ...prev, [item.title]: true }));
                    }
                }
            });
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);
    
    // Toggle submenu
    const toggleSubmenu = (menuTitle) => {
        setExpandedMenus(prev => ({
            ...prev,
            [menuTitle]: !prev[menuTitle]
        }));
    };
    
    // Check if path is active
    const isActive = (path) => {
        if (path === '/admin') {
            return location.pathname === '/admin';
        }
        return location.pathname.startsWith(path);
    };
    
    // Check if submenu item is active
    const isSubmenuActive = (item) => {
        return item.submenu?.some(sub => isActive(sub.path));
    };
    
    // Handle mobile menu close when clicking a link
    const handleLinkClick = () => {
        if (isMobile) {
            setIsCollapsed(true);
        }
    };
    
    return (
        <>
            {/* Mobile Overlay */}
            {isMobile && !isCollapsed && (
                <div 
                    className="sidebar-overlay"
                    onClick={() => setIsCollapsed(true)}
                />
            )}
            
            {/* Sidebar */}
            <aside className={`admin-sidebar ${isCollapsed ? 'collapsed' : ''} ${isMobile ? 'mobile' : ''}`}>
                {/* Sidebar Header */}
                <div className="sidebar-header">
                    <Link to="/admin" className="sidebar-logo" onClick={handleLinkClick}>
                        {/* <img src={Logo} alt="E-AquaHealth" /> */}
                        {!isCollapsed && (
                            <div className="logo-text">
                                <span className="brand-name">E-AquaHealth</span>
                                <span className="admin-label">Admin Panel</span>
                            </div>
                        )}
                    </Link>
                    
                    <button 
                        className="sidebar-toggle"
                        onClick={() => setIsCollapsed(!isCollapsed)}
                    >
                        {isCollapsed ? <img src={Menu} alt="" /> : <img src={X} alt="" />}
                    </button>
                </div>
                
                {/* Admin Info */}
                {/* {!isCollapsed && (
                    <div className="admin-info">
                        <div className="admin-avatar">
                            <img 
                                src={user?.avatar || `https://ui-avatars.com/api/?name=${encodeURIComponent(user?.first_name + ' ' + user?.last_name)}&background=0f766e&color=ffffff`}
                                alt="Admin Avatar"
                            />
                            <div className="status-indicator online"></div>
                        </div>
                        <div className="admin-details">
                            <h4>{user?.first_name} {user?.last_name}</h4>
                            <p>Super Administrator</p>
                            <div className="admin-badges">
                                <span className="badge primary">Online</span>
                                <span className="badge success">Verified</span>
                            </div>
                        </div>
                    </div>
                )} */}
                
                {/* Navigation Menu */}
                <nav className="sidebar-nav">
                    <div className="nav-content">
                        {menuItems.map((section, sectionIndex) => (
                            <div key={sectionIndex} className="nav-section">
                                {/* {!isCollapsed && (
                                    <div className="section-header">
                                        <span className="section-title">{section.title}</span>
                                        <div className="section-line"></div>
                                    </div>
                                )} */}
                                
                                <ul className="nav-list">
                                    {section.items.map((item, itemIndex) => (
                                        <li key={itemIndex} className="nav-item">
                                            {item.submenu ? (
                                                <>
                                                    <button
                                                        className={`nav-link submenu-trigger ${
                                                            isSubmenuActive(item) ? 'active' : ''
                                                        }`}
                                                        onClick={() => toggleSubmenu(item.title)}
                                                        title={isCollapsed ? item.title : ''}
                                                    >
                                                        <div className="nav-link-content">
                                                            <div className="nav-icon">
                                                                <img src={item.icon} alt={item.title} />
                                                            </div>
                                                            {!isCollapsed && (
                                                                <div className="nav-text">
                                                                    <span className="nav-title">{item.title}</span>
                                                                    <span className="nav-description">{item.description}</span>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {!isCollapsed && (
                                                            <div className="nav-actions">
                                                                {item.badge && (
                                                                    <span className={`nav-badge ${
                                                                        isNaN(item.badge) ? 'text' : 'number'
                                                                    }`}>
                                                                        {item.badge}
                                                                    </span>
                                                                )}
                                                                <div className={`submenu-arrow ${
                                                                    expandedMenus[item.title] ? 'expanded' : ''
                                                                }`}>
                                                                    <img src={ChevronRight} alt="" />
                                                                </div>
                                                            </div>
                                                        )}
                                                    </button>
                                                    
                                                    {/* Submenu */}
                                                    <ul className={`submenu ${
                                                        expandedMenus[item.title] && !isCollapsed ? 'expanded' : ''
                                                    }`}>
                                                        {item.submenu.map((subItem, subIndex) => (
                                                            <li key={subIndex} className="submenu-item">
                                                                <Link
                                                                    to={subItem.path}
                                                                    className={`submenu-link ${
                                                                        isActive(subItem.path) ? 'active' : ''
                                                                    }`}
                                                                    onClick={handleLinkClick}
                                                                >
                                                                    <div className="submenu-icon">
                                                                        <img src={subItem.icon} alt={subItem.title} />
                                                                    </div>
                                                                    <span className="submenu-title">{subItem.title}</span>
                                                                </Link>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </>
                                            ) : (
                                                <Link
                                                    to={item.path}
                                                    className={`nav-link ${isActive(item.path) ? 'active' : ''}`}
                                                    onClick={handleLinkClick}
                                                    title={isCollapsed ? item.title : ''}
                                                >
                                                    <div className="nav-link-content">
                                                        <div className="nav-icon">
                                                            <img src={item.icon} alt={item.title} />
                                                        </div>
                                                        {!isCollapsed && (
                                                            <div className="nav-text">
                                                                <span className="nav-title">{item.title}</span>
                                                                <span className="nav-description">{item.description}</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                    {!isCollapsed && item.badge && (
                                                        <span className={`nav-badge ${
                                                            isNaN(item.badge) ? 'text' : 'number'
                                                        }`}>
                                                            {item.badge}
                                                        </span>
                                                    )}
                                                </Link>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </nav>
                
                
                
                {/* Collapsed Tooltip */}
                {/* {isCollapsed && (
                    <div className="collapsed-tooltip">
                        <p>Hover over items for details</p>
                    </div>
                )} */}
            </aside>

        </>
    );
};

AdminSidebar.propTypes = {
    isCollapsed: PropTypes.bool.isRequired,
    setIsCollapsed: PropTypes.func.isRequired
};

export default AdminSidebar;